import React, {Component} from 'react';
import '../assets/styles/merch.scss';
import Img1 from '../assets/images/merch/Keep moving.png';
import Img2 from '../assets/images/merch/Last Page.png';
import Img3 from '../assets/images/merch/Music is Life.png';
import Hoodie from '../assets/images/merch/Dream hoodie.jpg';
import OnePlusOne from '../assets/images/merch/oneplusone.jpg';
import TwoPlusOne from '../assets/images/merch/twoplusone.jpg';
import Three from '../assets/images/merch/three.jpg';
import MerchCards from '../components/MerchCards';
import {Image, Message, Modal} from "semantic-ui-react";
import CompetitionDetails from "../components/CompetitionDetails";
import SizeChart from '../assets/images/merch/t size.jpg';

class Merch extends Component {

    constructor() {
        super();

        this.state={
            show:false,
            setShow:(val)=>{
                this.setState({show:val})
            },
        }

        this.data = [
            {
                photo:Img1,
                originalPrice:400,
                price:350,
                name:"T-Shirt",
            },
            {
                photo:Img2,
                originalPrice:400,
                price:350,
                name:"T-Shirt",
            },
            {
                photo:Img3,
                originalPrice:400,
                price:350,
                name:"T-Shirt",
            },
            {
                photo:Hoodie,
                originalPrice:700,
                price:650,
                name:"Hoodie",
            },
            {
                photo:OnePlusOne,
                originalPrice:1000,
                price:950,
                name:"Combo",
            },
            {
                photo:TwoPlusOne,
                originalPrice:1350,
                price:1250,
                name:"Combo",
            },
            {
                photo:Three,
                originalPrice:1050,
                price:999,
                name:"Combo",
            },
        ]
    }

    render() {
        return (<>
            <div className={'merch'}>
                <Message info compact>
                    <h2>
                        Book your Merch Till 5 March 11:59 PM to Avail the Early Bird Offer
                    </h2>
                </Message>
                <div className="container">
                    <div className="row">
                        {this.data.map((item,index)=>{
                            return (<MerchCards {...item} setShow={this.state.setShow} key={index}/>)
                        })}
                    </div>
                </div>
            </div>

            <Modal
                size={'big'}
                open={this.state.show}
                onClose={() => this.state.setShow(false)}
                closeIcon={true}
                className={'competitions-modal'}
                style={{zIndex:'99'}}

            >

                <Modal.Content className={'modal-content'}>
                    <img style={{width:'100%'}} src={SizeChart}/>
                </Modal.Content>

            </Modal>
        </>);
    }
}

export default Merch;